export default __webpack_public_path__ + "static/media/suite-montanha2-main.2d7e5196.jpg";